import clsx from "clsx";
import { ChevronLeft, ChevronRight } from "react-feather";
import { CustomInterventionItem } from "../../../types";
import { Badge } from "../Badge";
import { Card } from "../Card";

type InterventionCardProps = {
  intervention: CustomInterventionItem;
  onClick: () => void;
  isSelected: boolean;
  anySelected?: boolean;
  sticky?: boolean;
};

export const InterventionCard = ({
  intervention,
  onClick,
  isSelected,
  anySelected = false,
  sticky = false,
}: InterventionCardProps) => {
  return (
    <Card
      className={clsx(
        "group animate-intro-fade cursor-pointer transition duration-standard ease-in-out hover:bg-white active:border-gray-100",
        isSelected ? "border-gray-300 !bg-white" : "border-gray-50 bg-gray-50",
        anySelected && !isSelected && "opacity-50",
        !anySelected && "!border-gray-200",
        sticky && "sticky bottom-2 top-2 z-10",
      )}
      onClick={onClick}>
      <div className="flex select-none items-center justify-between">
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-bold">{intervention.name}</h1>
            <Badge className="b" color={intervention.draft ? "gray" : "white"}>
              {intervention.draft ? "Draft" : "Published"}
            </Badge>
            {intervention.archived && <Badge>Archived</Badge>}
            <Badge>{intervention.visibility?.toString() || ""}</Badge>
          </div>

          <p className="text-sm text-gray-500">{intervention.description}</p>
        </div>

        <div className="flex translate-x-4 items-center gap-2 opacity-0 transition duration-standard ease-in-out group-hover:translate-x-0 group-hover:opacity-100 group-active:!translate-x-1">
          {isSelected ? <ChevronRight strokeWidth="1.2" /> : <ChevronLeft strokeWidth="1.2" />}
        </div>
      </div>
    </Card>
  );
};
